var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('img',{staticStyle:{"display":"none"},attrs:{"src":_vm.impressionTag,"border":"0","height":"1","width":"1","alt":"Advertisement"}})
}
var staticRenderFns = []

export { render, staticRenderFns }